import { render, staticRenderFns } from "./ExamAnswer.vue?vue&type=template&id=228fe17a&scoped=true"
import script from "./ExamAnswer.vue?vue&type=script&lang=js"
export * from "./ExamAnswer.vue?vue&type=script&lang=js"
import style0 from "./ExamAnswer.vue?vue&type=style&index=0&id=228fe17a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "228fe17a",
  null
  
)

export default component.exports